var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ellipsis",style:({ position: _vm.position })},[_c('div',{style:({ 'background-color': _vm.primaryColor })}),_c('div',{style:({ 'background-color': _vm.primaryColor })}),_c('div',{style:({ 'background-color': _vm.primaryColor })}),_c('div',{style:({ 'background-color': _vm.primaryColor })})])
}
var staticRenderFns = []

export { render, staticRenderFns }